// Aadhaar eSign options for the Allotment Payment Consent.
// Mirrors the backend normaliseRules (services/allotmentEsign/rules.js).
// Preselect only: the customer fills KYC first and signs with the name on the KYC form, so there is no "who signs" choice.
// projectIds: the new flow (KYC first, Pay Now / VA hidden until KYC, Aadhaar eSign) runs only for preselect
// bookings of these projects. Empty = nothing is enforced.
export const ESIGN_DEFAULTS = { enabled: false, askFor: "NOT_SIGNED", nameCheck: "FLAG", projectIds: [] };

export const ASK_FOR_OPTIONS = [
  { value: "NOT_SIGNED", label: "Any booking not yet e-signed" },
  { value: "NOTHING_PAID", label: "Only bookings with nothing paid yet" },
];
export const NAME_CHECK_OPTIONS = [
  { value: "OFF", label: "Off" },
  { value: "FLAG", label: "Record & flag mismatch" },
  { value: "REJECT", label: "Reject on mismatch" },
];

const pick = (options, value, fallback) => (options.some((o) => o.value === value) ? value : fallback);

export function normaliseEsignRules(raw) {
  const r = raw && typeof raw === "object" ? raw : {};
  return {
    enabled: r.enabled === true,
    askFor: pick(ASK_FOR_OPTIONS, r.askFor, ESIGN_DEFAULTS.askFor),
    nameCheck: pick(NAME_CHECK_OPTIONS, r.nameCheck, ESIGN_DEFAULTS.nameCheck),
    projectIds: Array.isArray(r.projectIds)
      ? [...new Set(r.projectIds.map((x) => String(x ?? "").trim()).filter(Boolean))]
      : [],
  };
}

const labelOf = (options, value) => options.find((o) => o.value === value)?.label;

export function esignSummary(rules) {
  const r = normaliseEsignRules(rules);
  if (!r.enabled) return null;
  return [
    "Aadhaar eSign",
    r.projectIds.length === 1 ? "1 project" : `${r.projectIds.length} projects`,
    labelOf(ASK_FOR_OPTIONS, r.askFor),
    `Name: ${labelOf(NAME_CHECK_OPTIONS, r.nameCheck)}`,
  ].join(" · ");
}

export const PLACEHOLDERS = [
  { tag: "{{customerName}}", help: "Customer's name as on the KYC form" },
  { tag: "{{customerMobile}}", help: "Customer's registered mobile number" },
  { tag: "{{bookingId}}", help: "Booking ID" },
  { tag: "{{projectName}}", help: "Project name" },
  { tag: "{{unitNo}}", help: "Unit number" },
  { tag: "{{securityDepositAmount}}", help: "Security deposit amount in figures" },
  { tag: "{{securityDepositAmountWords}}", help: "Security deposit amount in words" },
  { tag: "{{date}}", help: "Date of signing" },
];
